export const useTimeZoneOffset = (): string => {
  const tz = (new Date().getTimezoneOffset() * (-1)) / 60;

  return tz > 0 ? `+${tz.toString()}` : tz.toString();
};
